require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var component_1 = require("@loadable/component");

var Audio = component_1["default"](function () {
  return Promise.resolve().then(function () {
    return require('./audio');
  });
});
var Cover = component_1["default"](function () {
  return Promise.resolve().then(function () {
    return require('./cover');
  });
});
var File = component_1["default"](function () {
  return Promise.resolve().then(function () {
    return require('./file');
  });
});
var Gallery = component_1["default"](function () {
  return Promise.resolve().then(function () {
    return require('./gallery');
  });
});
var Heading = component_1["default"](function () {
  return Promise.resolve().then(function () {
    return require('./heading');
  });
});
var Image = component_1["default"](function () {
  return Promise.resolve().then(function () {
    return require('./image');
  });
});
var List = component_1["default"](function () {
  return Promise.resolve().then(function () {
    return require('./list');
  });
});
var Paragraph = component_1["default"](function () {
  return Promise.resolve().then(function () {
    return require('./paragraph');
  });
});
var Quote = component_1["default"](function () {
  return Promise.resolve().then(function () {
    return require('./quote');
  });
});
var Video = component_1["default"](function () {
  return Promise.resolve().then(function () {
    return require('./video');
  });
});
exports["default"] = {
  Audio: Audio,
  Cover: Cover,
  File: File,
  Gallery: Gallery,
  Heading: Heading,
  Image: Image,
  List: List,
  Paragraph: Paragraph,
  Quote: Quote,
  Video: Video
};